import { CmsApiRecommendedJobsBlockData } from 'modules/cms/api/types/CmsApiRecommendedJobs';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsRecommendedJobsBlock } from './CmsRecommendedJobsBlock';

export const CmsRecommendedJobsBlockMapping: CmsBlockMapping<CmsApiRecommendedJobsBlockData> =
  {
    invariant: [],
    width: ({ layout }) =>
      layout === 'SLIM' ? CmsBlockWidth.NARROW : CmsBlockWidth.GRID,
    Component: CmsRecommendedJobsBlock,

    AmpComponent: CmsRecommendedJobsBlock,
  };
